import { createFileRoute, redirect } from '@tanstack/react-router';

/** Merged into the Templates hub as the "Messenger" tab. Redirect keeps old
 *  links, bookmarks, and the builder pages' back-buttons working. */
export const Route = createFileRoute('/vendor/facebook/templates/')({
  beforeLoad: () => {
    throw redirect({ to: '/vendor/templates', search: { channel: 'messenger' } });
  },
});
